import { useMemo } from 'react';
import { useConnect } from '@lore/query-connect';
import { useUser } from '@lore/auth';
import isEventComplete from './eventCompleteness';

export default function useActiveEvents() {
  const currentUser = useUser();

  const result = useConnect('event.find', {
    where: {
      filter: { active: true, creatorId: currentUser.id }
    },
    pagination: {
      pageSize: 100,
      order: 'createdAt desc'
    }
  });

  const data = useMemo(() => (result.data || []).filter(isEventComplete), [result.data]);

  return { ...result, data };
}
